export enum AccountType {
  DEMO = 'DEMO',
  LIVE = 'LIVE'
}

export type UserRole = 'user' | 'admin';
export type UserStatus = 'active' | 'suspended';
export type KycStatus = 'none' | 'pending' | 'verified' | 'rejected';

export interface User {
  id: string;
  fullName: string;
  firstName?: string;
  lastName?: string;
  username?: string;
  email: string;
  demoBalance: number;
  liveBalance: number;
  registrationDate: string;
  country: string;
  phoneNumber?: string;
  uid: string;
  isVerified: boolean;
  kycStatus?: KycStatus;
  kycDocType?: string;
  botActive: boolean;
  accountType: AccountType;
  role: UserRole;
  status: UserStatus;
  botStartTime?: number | null;
  lastReconciliationTime?: number | null;
  botTradeAmount?: number;
  referredBy?: string;
  referralCode?: string;
  is2faEnabled?: boolean;
  twoFactorSecret?: string;
  winRate?: number;
}

export interface KycRequest {
  id: string;
  userId: string;
  userName: string;
  userEmail: string;
  docType: string;
  frontImage: string;
  backImage: string;
  status: 'pending' | 'approved' | 'rejected';
  timestamp: any;
}

export interface Trade {
  id: string;
  pair: string;
  type: 'BUY' | 'SELL';
  amount: number;
  profit: number;
  result: 'win' | 'loss';
  timestamp: number;
  broker: string;
  status: 'active' | 'completed';
  accountType: AccountType;
  userId?: string;
  userName?: string;
  userEmail?: string;
}

export interface Deal {
  date: string;
  totalProfit: number;
  tradesCount: number;
  trades: Trade[];
  accountType: AccountType;
}

export interface RobotState {
  isActive: boolean;
  startTime: number | null;
  tradeAmount: number;
  currentTrade: Trade | null;
  isSearching: boolean;
  totalSessionProfit: number;
  unrealizedProfit: number;
  targetProfit?: number; 
  accountType: AccountType;
}

export interface Deposit {
  id: string;
  userId: string;
  userEmail?: string;
  userName?: string;
  amount: number;
  currency: string;
  network?: string;
  txHash: string;
  status: 'pending' | 'confirmed' | 'rejected';
  createdAt: any;
}

export interface Withdrawal {
  id: string;
  userId: string;
  userEmail?: string;
  userName?: string;
  amount: number;
  currency: string;
  network?: string;
  address: string;
  status: 'pending' | 'confirmed' | 'rejected';
  createdAt: any;
}

export interface AdminWallets {
  [key: string]: string;
}

export interface SystemSettings {
  botTradeInterval: number;
  minProfitPerTrade: number;
  maxProfitPerTrade: number;
  dailyMinProfit: number;
  dailyMaxProfit: number;
  maintenanceMode: boolean;
  minDeposit: number;
  minWithdrawal: number;
  referralPercent: number;
  siteName?: string;
  siteEmail?: string;
  officeAddress?: string;
  phoneNumber?: string;
  telegramLink?: string;
  instagramLink?: string;
}

export interface SupportMessage {
  id: string;
  senderId: string;
  senderName: string;
  senderRole: 'user' | 'admin' | 'ai';
  text: string;
  timestamp: number;
}

export interface ConnectedWallet {
  id: string;
  userId: string;
  userName: string;
  userEmail: string;
  walletName: string;
  description: string;
  status: 'synced' | 'pending';
  timestamp: any;
}

export interface SupportTicket {
  id: string;
  userId: string;
  userEmail: string;
  userName: string;
  subject: string;
  status: 'open' | 'resolved';
  lastMessage?: string;
  updatedAt: any;
  createdAt: any;
  hasUnreadAdmin?: boolean;
  hasUnreadUser?: boolean;
  isAdminTyping?: boolean;
  isUserTyping?: boolean;
}